import DeletedSalesOrders from './DeletedSalesOrders';

export default DeletedSalesOrders;
